import './project-section.scss';
import 'slick-carousel';

export default () => {
	// Slick Slider
	$( '.js-project-detail' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		rows: 0,
		appendDots: '.project-section__slick-nav',
		nextArrow: '<button class="slick-next"><i class="fa-solid fa-arrow-right"></i></button>',
		prevArrow: '<button class="slick-prev"><i class="fa-solid fa-arrow-left"></i></button>',
	} );

	setTimeout( function () {
		$( '.project-section__slide img' ).each( function ( i, el ) {
			if ( $( '.project-section__slick-nav button' )[ i - 1 ] ) $( '.project-section__slick-nav button' )[ i - 1 ].setAttribute( 'style', `--image:url(${el.src})` );
		} );
	}, 500 );
};
